<ng-container *ngIf="showMyMessage">
  <div class="row m-2 p-2" style="background-color: green; color: honeydew">
    <p><i class="fa fa-circle-check"></i>Saved Successfully</p>
  </div>
</ng-container>
<ng-template [ngIf]="passengerDetailsForm">
  <form [formGroup]="passengerDetailsForm">

    <div class="card p-4 mt-4 bg-image passengerdeatils commonFormsCss">

      <div class="sub-container container mt-4 commonFormsCss">
        <h2><i class="fa fa-id-card"></i> Passenger Details {{ inp_passengerDetail_group_value('passengerID') }}</h2>
        <div class="card box-border p-2">
          <div class="row">
            <!--YOUR BOOKKING SCREEN-->
            <ng-template
              [ngIf]="passengerDetailScreenData.bookingPassengerDetailType === 'your-booking-screen-passenger'">
              <div class="col-md-6">

                <h2 class="ms-4 mb-0 mt-3 bold">{{ inp_passengerDetail_group_value('passengerNameTitle') }} {{
                  inp_passengerDetail_group_value('passengerName') }} {{
                  inp_passengerDetail_group_value('passengerSurName') }}</h2>

              </div>
            </ng-template>
            <!--END YOUR BOOKING SCREEN-->
            <!--OFFER PRICE SCREEN-->

            <ng-template
              [ngIf]="passengerDetailScreenData.bookingPassengerDetailType === 'offer-price-screen-passenger'">
              <div class="col-2" formGroupName="passengerDetail">
                <span class="smx">Title</span><br />
                <select class="form-select" formControlName="passengerNameTitle">

                  <option *ngFor="let UserPrefix of userPrefixName">{{ UserPrefix }}</option>
                </select>
              </div>
              <div class="col-2" formGroupName="passengerDetail">
                <span class="smx">First Name</span><br />
                <input type="text" class="form-control" formControlName="passengerName" />
              </div>
              <div class="col-2" formGroupName="passengerDetail">
                <span class="smx">Last Name</span><br />
                <input type="text" class="form-control" formControlName="passengerSurName" />
              </div>
            </ng-template>
            <!--END OFFER PRICE SCREEN-->

            <div class="col-2" formGroupName="passengerDetail">
              <span class="smx">Date of Birth</span><br />
              <input id="ddate" name="ddate" type="date" class="form-control" formControlName="passengerDOB" />
            </div>
            <div class="col-2" formGroupName="passengerDetail">
              <span class="smx">Gender</span><br />

              <select class="form-select" formControlName="passengerGender">

                <option *ngFor="let gender of gender">{{ gender }}</option>
              </select>
            </div>
            <div class="col-2" formGroupName="passengerDetail">
              <span class="smx">Nationality</span><br />

              <select class="form-select" formControlName="nationalities">
                <option value="" selected disabled>Please Select a Country</option>
                <option *ngFor="let nationality of nationalities" [value]="nationality.code">{{ nationality.name }}
                </option>

              </select>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-5 p-3">
              <div class="card p-4 box-border">
                <div class="form-check pl-0">

                  <ng-template
                    [ngIf]="passengerDetailScreenData.bookingPassengerDetailType === 'your-booking-screen-passenger'">
                    <input class="me-2" type="radio" formControlName="passengerDocumentType" id="passengerDocumentType"
                      value="identityDocument" />

                  </ng-template>
                  <label class="form-check-label" for="passengerDocumentType"> Identity Document </label>
                </div>
                <div formGroupName="passengerIdentityDetail">
                  <select class="form-select mt-3 mb-3 wd146" formControlName="identity">
                    <option *ngFor="let identity of identity" [value]="identity.value">{{ identity.name }}</option>
                  </select>
                  <input type="text" placeholder="ID/Passport Number" class="form-control mt-2"
                    formControlName="idnumber" value="" />
                  <br />
                  <span class="smx mt-4">Redress Number (Optional)</span>

                  <br /><input type="text" placeholder="Redress Number" class="form-control mt-2"
                    formControlName="redressNumber" value="" />
                  <br /><span class="smx mt-4">Issuing Country</span><br />
                  <select class="form-select wd200" formControlName="issuingCountry">
                    <option value="" selected disabled>Please Select a Country</option>
                    <option *ngFor="let nationality of nationalities" [value]="nationality.code">{{ nationality.name }}
                    </option>
                  </select> <br />

                  <span class="smx mt-2">Expiry Date</span><br />
                  <input id="ddate" name="ddate" type="date" class="form-control" formControlName="expiryDate" />
                </div>
              </div>
            </div>
            <div class="col-sm-1"></div>
            <div class="col-sm-6 mt-3">
              <div class="card p-4 box-border" formGroupName="passengerAddressDetail">
                <div class="flexTop">
                  <input type="checkbox" formControlName="enableAddressDetail" class="me-2 mt-2" />
                  <h3>Address at Destination</h3>
                </div>
                <input type="text" placeholder="Address 1" class="form-control mt-4" formControlName="address1" />
                <input type="text" placeholder="Address 2" class="form-control mt-4" formControlName="address2" />
                <input type="text" placeholder="City" class="form-control mt-4" formControlName="city" />
                <input type="text" placeholder="Zip" class="form-control mt-4" formControlName="zip" />

                <select class="form-select mt-4 wd200" placeholder="Select Country" formControlName="country">

                  <option value="" selected disabled>Please Select a Country</option>
                  <option *ngFor="let nationality of nationalities" [value]="nationality.code">{{ nationality.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-5">
              <div class="card box-border p-4">
                <div class="form-check pl-0">
                  <ng-template
                    [ngIf]="passengerDetailScreenData.bookingPassengerDetailType === 'your-booking-screen-passenger'">
                    <input class="me-2" type="radio" formControlName="passengerDocumentType" value="loyaltyProgram" />
                  </ng-template>
                  <label class="form-check-label" for="passengerDocumentType"> Loyalty Programme </label>
                </div>
                <div formGroupName="passengerLoyaltyDetail">
                  <select class="form-select form-control mt-2 wd146" formControlName="loyaltyProgram">
                    <option value="" selected>None</option>

                    <option *ngFor="let loyaltyProgram of loyaltyProgram" value="{{loyaltyProgram}}">{{ loyaltyProgram
                      }}</option>

                  </select>
                  <input type="text" class="form-control mt-2" formControlName="loyaltyProgramNumber"
                    placeholder="Account #" value="" />
                </div>
              </div>
            </div>
          </div>
          <div class="btn-border">
            <button type="button" class="btn btn-outline-info pull-right btncont mt-2 p-2" role="button"
              (click)="onSubmit()"><i class="fa fa-save"></i> Save</button>
          </div>
        </div>
        <div class="float-right" style="position: absolute; top: 20px; right: 20px">
          <button (click)="closePanel()" class="ba-btn ba-btn-sq-sm" role="button"><i class="fa fa-times"></i></button>
        </div>
      </div>
    </div>
  </form>
</ng-template>